import React, { useState } from "react";
import emailjs from "emailjs-com";
import contactImage from "../assets/contactus.webp";

const ContactSection = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        childName: "",
        childDOB: "",
        email: "",
        phoneNumber: "",
        sessionRequired: "",
        date: new Date().toLocaleString()
    });

    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!formData.fullName) newErrors.fullName = "Full Name is required";
        if (!formData.childName) newErrors.childName = "Child Name is required";
        if (!formData.childDOB) newErrors.childDOB = "Child DOB is required";
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.phoneNumber) newErrors.phoneNumber = "Phone Number is required";
        if (!formData.sessionRequired) newErrors.sessionRequired = "Please select a session";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        setSuccessMsg("");

        emailjs
            .send(
                "service_zjbdz5u",
                "template_yr7d6v9",
                formData,
                "dMZoQjAsgWLuhtDUo"
            )
            .then(() => {
                setSuccessMsg("Your message has been sent successfully. We will contact you soon.");
                setLoading(false);

                setFormData({
                    fullName: "",
                    childName: "",
                    childDOB: "",
                    email: "",
                    phoneNumber: "",
                    sessionRequired: "",
                    date: new Date().toLocaleString()
                });

                setErrors({});
            })
            .catch(() => {
                setSuccessMsg("Something went wrong. Please try again.");
                setLoading(false);
            });
    };

    return (
        <section className="contact-section py-5">
            <div className="contact-bg-big-circle"></div>
            <div className="contact-leaf-overlay"></div>
            <div className="contact-circle-1"></div>
            <div className="contact-circle-2"></div>
            <div className="contact-circle-3"></div>

            <div className="container contact-content">
                <h2 className="contact-heading">Contact Us</h2>

                {successMsg && (
                    <div
                        style={{
                            background: "#e8f9ef",
                            padding: "12px 16px",
                            borderRadius: "6px",
                            color: "#145a2f",
                            fontWeight: "500",
                            marginBottom: "20px"
                        }}
                    >
                        {successMsg}
                    </div>
                )}

                <div className="row align-items-center">
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label htmlFor="fullName" className="form-label form-label-custom">Full Name*</label>
                                    <input
                                        type="text"
                                        id="fullName"
                                        className="form-control form-control-custom"
                                        placeholder="Your Name"
                                        value={formData.fullName}
                                        onChange={handleChange}
                                    />
                                    {errors.fullName && <small style={{ color: "red" }}>{errors.fullName}</small>}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="childName" className="form-label form-label-custom">Child Name*</label>
                                    <input
                                        type="text"
                                        id="childName"
                                        className="form-control form-control-custom"
                                        placeholder="Child Name"
                                        value={formData.childName}
                                        onChange={handleChange}
                                    />
                                    {errors.childName && <small style={{ color: "red" }}>{errors.childName}</small>}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="childDOB" className="form-label form-label-custom">Child DOB*</label>
                                    <input
                                        type="text"
                                        id="childDOB"
                                        className="form-control form-control-custom"
                                        placeholder="Enter here"
                                        value={formData.childDOB}
                                        onChange={handleChange}
                                    />
                                    {errors.childDOB && <small style={{ color: "red" }}>{errors.childDOB}</small>}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label form-label-custom">Email*</label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="form-control form-control-custom"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && <small style={{ color: "red" }}>{errors.email}</small>}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="phoneNumber" className="form-label form-label-custom">Phone Number*</label>
                                    <input
                                        type="tel"
                                        id="phoneNumber"
                                        className="form-control form-control-custom"
                                        placeholder="Phone Number"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                    />
                                    {errors.phoneNumber && <small style={{ color: "red" }}>{errors.phoneNumber}</small>}
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="sessionRequired" className="form-label form-label-custom">Session Required*</label>
                                    <select
                                        id="sessionRequired"
                                        className="form-select form-control-custom"
                                        value={formData.sessionRequired}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select</option>
                                        <option value="Morning">Morning Session</option>
                                        <option value="Afternoon">Afternoon Session</option>
                                        <option value="Full Day">Full Day</option>
                                    </select>
                                    {errors.sessionRequired && <small style={{ color: "red" }}>{errors.sessionRequired}</small>}
                                </div>

                                <div className="col-12 mt-4">
                                    <button type="submit" className="btn btn-submit" disabled={loading}>
                                        {loading ? (
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "18px",
                                                    height: "18px",
                                                    border: "2px solid white",
                                                    borderRadius: "50%",
                                                    borderTop: "2px solid transparent",
                                                    animation: "spin 0.8s linear infinite"
                                                }}
                                            />
                                        ) : (
                                            "Submit"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>

                        <style>
                            {`
                @keyframes spin {
                  from { transform: rotate(0deg) }
                  to { transform: rotate(360deg) }
                }
              `}
                        </style>
                    </div>

                    <div className="col-lg-6">
                        <div className="contact-image-container ps-lg-5 rounded-2">
                            <img
                                src={contactImage}
                                alt="Contact Us"
                                className="img-fluid rounded-4"

                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;
